import React from "react"
import { useTranslation } from "react-i18next"
import { type TaskClassification } from "@/features/tasks"
import TaskStatusGroup from "@/features/tasks/components/task-status-group/task-status-group.tsx"
import {
  BROWN,
  NOTIFICATION_BLUE,
  NOTIFICATION_RED,
} from "@/utils/constants/colors-constants.ts"

export interface CurrentTasksListProps {
  filteredTasks: TaskClassification
}

export const TasksListCurrent: React.FC<CurrentTasksListProps> = ({
  filteredTasks,
}) => {
  const { t } = useTranslation()

  return (
    <>
      {filteredTasks.dueTasks.length > 0 && (
        <TaskStatusGroup
          tasks={filteredTasks.dueTasks}
          title={t("dueTasks")}
          backgroundColor={NOTIFICATION_RED}
        />
      )}
      {filteredTasks.currentTasks.length > 0 && (
        <TaskStatusGroup
          tasks={filteredTasks.currentTasks}
          title={t("currentTasks")}
          backgroundColor={BROWN}
        />
      )}
      {filteredTasks.futureTasks.length > 0 && (
        <TaskStatusGroup
          tasks={filteredTasks.futureTasks}
          title={t("futureTasks")}
          backgroundColor={NOTIFICATION_BLUE}
        />
      )}
    </>
  )
}
